(function(appContainerPlaceholder) {
    'use strict';

    angular.module('navigationController', [
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.Configuration',
            'MW.Influencers.AnalyticsService',
            'MW.Influencers.ActionBarService'
        ])
        .controller('navigationController', [
            '$location',
            '$window',
            '$mdDialog',
            '$mdMedia',
            '$q',
            '$translate',
            'CoreUserService',
            'CoreCompanyService',
            '$rootScope',
            'FAIRHAIR_WEB_URL',
            'ACCOUNTS_APP_URL',
            'ENV',
            'AnalyticsService',
            'ActionBarService',
            NavigationController
        ]);

    function NavigationController($location,
                                  $window,
                                  $mdDialog,
                                  $mdMedia,
                                  $q,
                                  $translate,
                                  CoreUserService,
                                  CoreCompanyService,
                                  $rootScope,
                                  FAIRHAIR_WEB_URL,
                                  ACCOUNTS_APP_URL,
                                  ENV,
                                  AnalyticsService,
                                  ActionBarService
                                  ) {

    this.actionBarService = ActionBarService;
    this.FAIRHAIR_WEB_URL = FAIRHAIR_WEB_URL;
    this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
    this.ENV = ENV;
    this.AnalyticsService = AnalyticsService;
    this.CoreCompanyService = CoreCompanyService;
    this.CoreUserService = CoreUserService;
    // this entitlement needs to be true to get from fairhair-web to icm-web. so set it.
    CoreUserService.isIcmCountriesEntitlement = true;
    this.$location = $location;
    this.$window = $window;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.$mdMedia = $mdMedia;
    this.$q = $q;
    this.$translate = $translate;
    this.currentTab = null;
    this.tabItems = [];
    this.headerText = 'Influencers';
    this.height = '500px';
    this.hideChrome = false;
    this.customAppContainerClass = '';
    this.navModuleEnvironment = 'production';

    this.$onInit = function() {
        this.isFullScreenEnabled = this.$location.absUrl().indexOf('fullscreen=true') > 0 ? true : false;
        
        if (this.ENV !== 'production') {
            this.navModuleEnvironment = 'staging';
        }

        CoreUserService.getCurrent(true)
                .then((user) => {
                    this.user = user;
                });
        CoreCompanyService.getCurrent(true)
                .then((selectedAccount) => {
                    this.company = selectedAccount;
                    this.initSelectedAccount = selectedAccount;
                });

        $rootScope.$on('$routeChangeStart', function onRouteChangeStart($event, newRoute) {
            $mdDialog.hide();
            this.hideChrome = this.isRouteChromeless(newRoute);
            this.customAppContainerClass = this.getAppContainerClass(newRoute);
        }.bind(this));

        $rootScope.$on('$routeChangeSuccess', function onRouteChangeSuccess($event, currentRoute) {
            this.hideChrome = this.isRouteChromeless(currentRoute);
            this.customAppContainerClass = this.getAppContainerClass(currentRoute);
            this.resetContentScroll();
            this.syncSubNavWithRoute();

            if(this.cachedTabItems){
                this.cachedTabItems.some(function(item, index){
                    if(currentRoute && item.link === currentRoute.$$route.originalPath){
                        this.currentTab = this.cachedTabItems[index];
                    } else if((this.cachedTabItems.length - 1) === index){
                        this.currentTab = {};
                    }
                }, this);
            }

            if(currentRoute.$$route && currentRoute.$$route.useActionBar){
                this.useActionBar = true;
            } else {
                this.useActionBar = false;
            }

            // if we are hiding the chrome (aka navigation header & sidebar), then we never load the nav module
            // which means we never resolve the miIaNavigationService.navItemsPromise.promise. we depend on that
            // promise resolving to remove the app container placeholder in the constructor of this controller.
            // ...so we need to clean up after the hideChrome route is ready
            if(this.hideChrome && appContainerPlaceholder) {
                appContainerPlaceholder.remove();
            }
        }.bind(this));
    };
}

    NavigationController.prototype.getScreenSize = function getScreenSize() {
        if(this.$mdMedia('xs')) {
            return 'xs';
        }
        if(this.$mdMedia('sm')) {
            return 'sm';
        }
        if(this.$mdMedia('md')) {
            return 'md';
        }
        if(this.$mdMedia('lg')) {
            return 'lg';
        }
        if(this.$mdMedia('xl')) {
            return 'xl';
        }
    };

    NavigationController.prototype.isSubLinkActive = function isSubLinkActive(itemPath) {
        return this.$location.path().indexOf(itemPath) !== -1;
    };

    NavigationController.prototype.resetContentScroll = function resetContentScroll (scrollParams) {
        var scrollContainerElement = $('md-content.mw-flex-padding');

        if (scrollContainerElement.length) {
            scrollContainerElement.animate(
                {
                    scrollTop: 0
                },
                {
                    duration: scrollParams && scrollParams.duration ? scrollParams.duration : 0
                }
            );
        }
    };

    NavigationController.prototype.userMenuHeaderClick = function userMenuHeaderClick() {
        this.$window.location.href = this.FAIRHAIR_WEB_URL + '/settings/personal';
    };

    NavigationController.prototype.logout = function logout() {
        this.$window.location.href = this.ACCOUNTS_APP_URL + '/logout';
    };

    NavigationController.prototype.selectAccount = function selectAccount(account) {
        var currentAccountId = this.CoreCompanyService.getId();

        if (currentAccountId !== account._id) {
            this.AnalyticsService.trackNavigation('switch_account', {
                type: 'primary',
                label: 'Influencers',
                url: '/influencers',
                sourceUrl: this.$location.url(),
                pinStatus: 'open',
                language: this.user.language
            });

            this.showCompanySwitchProgress();
            this.$window.location.href = this.ACCOUNTS_APP_URL + '/switchingCompany/' + account._id;
        }
    };

    NavigationController.prototype.showCompanySwitchProgress = function showCompanySwitchProgress() {
        this.$mdDialog.show({
            template:
                '<md-dialog style="background:transparent;box-shadow:none;">' +
                '    <div style="margin:auto;" class="spinner"></div>' +
                '</md-dialog>',
            parent: angular.element(document.body),
            fullscreen: false,
            disableParentScroll: true
        });
    };

    NavigationController.prototype.selectNavItem = function selectNavItem(navItem) {
        if (navItem.title !== 'Help' ) {
            this.AnalyticsService.trackNavigation('click_nav', {
                type: 'primary',
                label: 'Influencers',
                url: '/influencers',
                sourceUrl: this.$location.url(),
                pinStatus: 'open',
                language: this.user.language
            });
        }

        // the contact form has an event handler for navigating away from an incomplete form, trigger it
        // ...this probably isn't the best way, should revisit this as this list of custom handlers grows
        if(this.$location.url().match(/contact\/(create|edit)/)) {
            // prevent us from updating the icon state before we know if location change is successful
            this.navItems.forEach(function(navItem) {
                navItem.isActive = (navItem.title === 'Influencers') ? true : false;
            });

            this.$rootScope.$broadcast('$locationChangeStart', navItem.link, this.$location.url());
        } else {
            // navigate within app, or reload page/app
            if(navItem.link.match('/influencers') || navItem.link.match('/newswire')) {
                this.$location.url(navItem.link);
            } else {
                this.$window.location.href = navItem.link;
            }
        }
    };

    NavigationController.prototype.selectTabItem = function selectTabItem(tabItem){
        //For now, we only want to do this for the search route, search controller listens to 'currentTabSelected'
        if(this.currentTab && this.currentTab.link && this.currentTab.title === 'influencers-subtabs__search' && tabItem.link === this.currentTab.link){
            this.$rootScope.$broadcast('currentTabSelected');
        }
        else {
            this.tabItems.forEach(function(item){
                if(item.link === tabItem.link){
                    item.isActive = true;
                } else {
                    item.isActive = false;
                }
            });
            this.selectNavItem(tabItem);
        }
    };

    NavigationController.prototype.getAppContainerClass = function getAppContainerClass(route) {
        if(route && route.$$route && route.$$route.customContainerClass) {
            return route.$$route.customContainerClass;
        } else {
            return '';
        }
    };

    NavigationController.prototype.isRouteChromeless = function isRouteChromeless(route) {
        return route && route.$$route && (route.$$route.hideNavigation === true || route.$$route.isChromeless === true);
    };

    NavigationController.prototype.help = function help() {
        if(this.$window._elev && this.$window._elev.open) {
            this.$window._elev.open();
        }
    };

    NavigationController.prototype.syncSubNavWithRoute = function syncSubNavWithRoute() {
        this.CoreUserService.getInfluencersSubTabs().then(function(subNav){
            this.iterateSubNavWithRoute(subNav);
         }.bind(this)).catch(function(subNav){
            this.iterateSubNavWithRoute(subNav);
         }.bind(this));
    };

    NavigationController.prototype.hasTabItems = function hasTabItems() {
        return (Array.isArray(this.tabItems) && (this.tabItems.length > 0));
    };

    NavigationController.prototype.iterateSubNavWithRoute = function iterateSubNavWithRoute(result) {
        this.cachedTabItems = result.slice();
        this.tabItems = result;

        this.tabItems.some(function(tabItem, index) {
            var isActive = false;
            if(typeof(tabItem.customIsActive) === 'function') {
                isActive = tabItem.customIsActive();
            } else {
                isActive = (tabItem.link === this.$location.path());
            }
            tabItem.isActive = isActive;

            if(isActive) {
                this.cachedTabItems[index].isActive = true;
                this.currentTab = this.cachedTabItems[index];
            }

            return isActive;
        }, this);
    };

}(window.appContainerPlaceholder));
